import { render, staticRenderFns } from "./ProjectBidTemplates.vue?vue&type=template&id=57ab8dfc"
import script from "./ProjectBidTemplates.vue?vue&type=script&lang=js"
export * from "./ProjectBidTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports